/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_FiInputs */

const en_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const es_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const de_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const zh_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const ar_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const fr_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const vi_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const sw_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const th_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const bs_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const ja_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const ko_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const pt_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const it_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const sv_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const nl_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const da_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const nb_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const fi_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const pl_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const ru_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const tr_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const hi_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const id_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const ms_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const cs_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const el_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const he_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const af_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

const hu_nav_language_fi = /** @type {(inputs: Nav_Language_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suomi`)
};

/**
* | output |
* | --- |
* | "Suomi" |
*
* @param {Nav_Language_FiInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_fi = /** @type {((inputs?: Nav_Language_FiInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_FiInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_fi(inputs)
	if (locale === "de") return de_nav_language_fi(inputs)
	if (locale === "zh") return zh_nav_language_fi(inputs)
	if (locale === "ar") return ar_nav_language_fi(inputs)
	if (locale === "fr") return fr_nav_language_fi(inputs)
	if (locale === "vi") return vi_nav_language_fi(inputs)
	if (locale === "sw") return sw_nav_language_fi(inputs)
	if (locale === "th") return th_nav_language_fi(inputs)
	if (locale === "bs") return bs_nav_language_fi(inputs)
	if (locale === "ja") return ja_nav_language_fi(inputs)
	if (locale === "ko") return ko_nav_language_fi(inputs)
	if (locale === "pt") return pt_nav_language_fi(inputs)
	if (locale === "it") return it_nav_language_fi(inputs)
	if (locale === "sv") return sv_nav_language_fi(inputs)
	if (locale === "nl") return nl_nav_language_fi(inputs)
	if (locale === "da") return da_nav_language_fi(inputs)
	if (locale === "nb") return nb_nav_language_fi(inputs)
	if (locale === "fi") return fi_nav_language_fi(inputs)
	if (locale === "pl") return pl_nav_language_fi(inputs)
	if (locale === "ru") return ru_nav_language_fi(inputs)
	if (locale === "tr") return tr_nav_language_fi(inputs)
	if (locale === "hi") return hi_nav_language_fi(inputs)
	if (locale === "id") return id_nav_language_fi(inputs)
	if (locale === "ms") return ms_nav_language_fi(inputs)
	if (locale === "cs") return cs_nav_language_fi(inputs)
	if (locale === "el") return el_nav_language_fi(inputs)
	if (locale === "he") return he_nav_language_fi(inputs)
	if (locale === "af") return af_nav_language_fi(inputs)
	if (locale === "hu") return hu_nav_language_fi(inputs)
	return en_nav_language_fi(inputs)
});